<template>
  <v-container grid-list-xs class="pt-0 px-3">
    <v-layout row style="padding-left: 60px;" wrap>
      <v-flex>
        <nuxt-link :to="localePath('/projects/' + getObject(0).slug + '/')">
          <div class="v-responsive v-image img-border hover-darken">
            <div
              class="v-responsive__sizer"
              style="padding-bottom: 56.1798%;"
            />
            <div
              v-lazy:background-image="getObject(0)._thumbnail"
              style="background-position: center center;  z-index:1"
              class="v-image__image v-image__image--cover lazy"
            />
          </div>
        </nuxt-link>
        <h5 class="pt-3">
          {{ getObject(0).title }}
        </h5>
        <p class="mb-2" style="word-break: break-word;">
          {{ getObject(0).synoposis }}
        </p>
        <nuxt-link
          v-for="(tag, index) in getObject(0).tags"
          :key="index"
          :to="localePath('/projects?q=' + tag)"
          color="primary"
          text-color="white"
        >
          #{{ tag }}
        </nuxt-link>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ActivityCardProduct',
  props: {
    activity: {
      type: [Object],
      required: true,
      default: () => ({
        param: value,
        param2: value
      })
    },
    getCardUser: {
      type: [Object],
      required: false,
      default: () => ({})
    },
    getObject: {
      type: [Function],
      required: false,
      default: function() {}
    }
  },
  methods: {
    getSource(index) {
      return this.getObject(index)._thumbnail
    },
    getUrl(index) {
      return this.getObject(index).get_absolute_url
    }
  }
}
</script>
